import { Trans } from 'react-i18next';
import styled from 'styled-components';

import { MedicalDataAccessAuthorization } from '@dreryk/egabinet-patient-frontend-api';

import { fonts } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';

type WithdrawMedicalDataAccessAuthorizationActionContentProps = {
   readonly firstName: MedicalDataAccessAuthorization['firstName'];
   readonly lastName: MedicalDataAccessAuthorization['lastName'];
};

const Bold = styled.span`
   font-weight: ${fonts.fontWeightBold};
`;

const WithdrawMedicalDataAccessAuthorizationActionContent = (
   props: WithdrawMedicalDataAccessAuthorizationActionContentProps
): JSX.Element => {
   return (
      <Trans
         i18nKey={patientConsentsAndAuthorizationsTranslationKeys.authorizations.withdrawAuthorizationMessage}
         values={{ firstName: props.firstName, lastName: props.lastName }}
         components={{ bold: <Bold /> }}
      />
   );
};

export { WithdrawMedicalDataAccessAuthorizationActionContent };
